module.exports = __webpack_public_path__ + "img/logopoon2.8545e50a.png";